/**
 * ParentPage allows for child
 * iframes to communicate with
 * the parent page.
 */
class ParentPage {
  constructor(placementType, instanceId) {
    this.placementType = placementType;
    this.instanceId = instanceId;

    if (!placementType) {
      throw new Error('No placementType passed to ParentPage');
    }

    if (!instanceId) {
      throw new Error('No instanceId passed to ParentPage');
    }

    this.events = [];
    this._onNewMsg = this._onNewMsg.bind(this);
  }

  getParentPageSessionToken() {
    return new Promise((resolve) => {
      function responseCallback(ev) {
        const { type, data } = ev.data;
        if (type === 'session-token-response') {
          resolve(data.parentPageSessionToken);
          window.removeEventListener('message', responseCallback);
        }
      }

      window.addEventListener('message', responseCallback);
      this.postMessage('session-token-request');
    });
  }

  listen(events) {
    if (!events?.length) {
      throw new Error('No events passed to listen');
    }

    if (this.events.length === 0) {
      this.events = this.events.concat(events);
      window.addEventListener('message', this._onNewMsg);
    } else {
      this.events = this.events.concat(events);
    }
  }

  stopListening() {
    window.removeEventListener('message', this._onNewMsg);
  }

  postMessage(type, data) {
    window.parent.postMessage(
      {
        meta: {
          placementType: this.placementType,
          instanceId: this.instanceId,
          type,
        },
        data: data || {},
      },
      '*'
    );
  }

  _onNewMsg(ev) {
    const { type, data } = ev.data;
    const event = this.events.find(([t]) => t === type);

    if (!event) {
      return;
    }

    event[1](data);
  }
}

export default ParentPage;
